var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitTunneling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0L9.2175 1.7175L7.0575 3.8775L8.1225 4.9425L10.2825 2.7825L12 4.5V0H7.5ZM4.5 0H0V4.5L1.7175 2.7825L5.25 6.3075V12H6.75V5.6925L2.7825 1.7175L4.5 0Z",
    fill: "#4E72B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitTunneling);
export default __webpack_public_path__ + "static/media/split-tunneling.9e6f6574614b30a8fa5483b6e26b49af.svg";
export { ForwardRef as ReactComponent };